import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-privacy-policy',
  template: `
    <h2>Política de Privacidad</h2>
    <ng-container *ngIf="pdfUrl; else loading">
      <iframe
        [src]="pdfUrl | safeUrl"
        width="100%"
        height="500px"
        style="border: none;"
        title="Política de Privacidad PDF"
      ></iframe>
    </ng-container>
    <ng-template #loading>
      <p>Cargando...</p>
    </ng-template>
  `,
  styles: [':host { display: block; padding: 16px; height: 100%; }'],
})
export class PrivacyPolicyPage implements OnInit {
  pdfUrl: string | null = null;

  constructor(private userService: UserService) {}

  ngOnInit() {
    this.userService.getLatestPrivacyPolicy().subscribe((data: any) => {
      this.pdfUrl = data.pdf_file ? `${data.pdf_file}#view=FitH` : null;
    });
  }
}
